export default __webpack_public_path__ + "static/media/squares-icon.6d8d4226.svg";